module.exports = __webpack_public_path__ + "img/solution-preevision2x-system-pic.a7cd22cf.png";